let url = 'http://localhost:8000/';
url = 'https://bkfutsalvinto.vaixs.net/public/';

export const environment = {
  env: 'DEFAULT',
  production: false,
  serverBaseUrl: url + 'api',
  serverUrl: url + 'api',
  imgUrl: url + ''
};
